function ensureCodedField(raw) {
  if (!raw || typeof raw !== "object") {
    return { code: "", description: "" };
  }
  return {
    code: raw.code != null ? String(raw.code) : "",
    description: raw.description != null ? String(raw.description) : "",
  };
}

function getLineForSku(sku, productCodes) {
  const code =
    sku && sku.productLine && sku.productLine.code != null
      ? String(sku.productLine.code).trim()
      : "";
  if (!code) {
    return null;
  }

  const lines = (productCodes && productCodes.productLines) || [];
  return lines.find((line) => String(line.code).trim() === code) || null;
}

/**
 * Simulates the on-site SKU description. Website-style copy for voice + format
 * comes from productCodes `websiteLabel` values; trailing sku.detail comes from
 * the catalog.
 */
export function generatedSkuDescription(sku, productCodes) {
  const parts = [];
  const line = getLineForSku(sku, productCodes);
  const voices = (sku && sku.voices) || [];
  const primary = voices.find((v) => v && v.primaryFlag) || voices[0];
  if (primary && line) {
    const vCode = primary.code != null ? String(primary.code).trim() : "";
    if (vCode) {
      const refVoice = (line.voices || []).find(
        (x) => x && x.code != null && String(x.code).trim() === vCode,
      );
      if (refVoice) {
        if (refVoice.usedInWebsiteDescription === true) {
          const websiteLabel =
            refVoice.websiteLabel != null
              ? String(refVoice.websiteLabel).trim()
              : "";
          const vd =
            websiteLabel ||
            (refVoice.description != null
              ? String(refVoice.description).trim()
              : "");
          if (vd) {
            parts.push(vd);
          }
        }
        if (
          refVoice.instrument != null &&
          String(refVoice.instrument).trim() !== ""
        ) {
          parts.push(String(refVoice.instrument).trim());
        }
      }
    }
  }

  const fmt = ensureCodedField(sku && sku.format);
  const fmtCode = fmt.code.trim();
  if (line && fmtCode) {
    const refFmt = (line.formats || []).find(
      (f) => f && f.code != null && String(f.code).trim() === fmtCode,
    );
    if (refFmt) {
      if (refFmt.ensemble != null && String(refFmt.ensemble).trim() !== "") {
        parts.push(String(refFmt.ensemble).trim());
      }
      const websiteLabel =
        refFmt.websiteLabel != null ? String(refFmt.websiteLabel).trim() : "";
      const fd =
        websiteLabel ||
        (refFmt.description != null ? String(refFmt.description).trim() : "");
      if (fd) {
        parts.push(fd);
      }
      if (
        refFmt.accompaniment != null &&
        String(refFmt.accompaniment).trim() !== ""
      ) {
        parts.push(String(refFmt.accompaniment).trim());
      }
    }
  }

  const detail = sku && sku.detail != null ? String(sku.detail).trim() : "";
  if (detail) {
    parts.push(detail);
  }
  return parts.join(" ");
}
